import { useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import api from 'api';
import useCallbackAsync from 'hooks/useCallbackAsync';
import { GeneralSuggestedAction } from 'models/SuggestedActions';
import { removeGeneralSuggestedAction } from '../utils';

const useGeneralThreeDotsOptions = (suggestion: GeneralSuggestedAction) => {
  const { t } = useTranslation();

  const queryClient = useQueryClient();

  const { type } = suggestion;

  const [onDontRemindMe, isMuting] = useCallbackAsync(async () => {
    await api.userSuggestedActions.muteGeneralSuggestedAction(type);

    removeGeneralSuggestedAction(queryClient, type);
  });

  const threeDotsOptions = useMemo(
    () => [
      {
        label: t('dontRemindMeAgain'),
        disabled: isMuting,
        onClick: onDontRemindMe,
      },
    ],
    [isMuting, onDontRemindMe, t],
  );

  return {
    isMuting,
    threeDotsOptions,
  };
};

export default useGeneralThreeDotsOptions;
